import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    setModalOpen,
    setParseDataOfCsvFile,
    setSelectedCsvItem,
    setSelectedCsvItemIndex,
    setModalType,
    setSelectedCsvFileName,
    setSelectedCsvFile
} from 'store/ResponseTemplate/actions';
import { Button, Typography, Box, Grid } from '@mui/material';
function RemoveTemmplateCsv() {
    const dispatch = useDispatch();
    const { selectedCsvItem, selectedCsvItemIndex, parsedCsvData } = useSelector((params) => params.response);
    const handleClose = () => {
        dispatch({ type: setSelectedCsvItem, selectedCsvItem: null });
        dispatch({ type: setSelectedCsvItemIndex, selectedCsvItemIndex: -1 });
        dispatch({ type: setModalOpen, modalOpen: false });
        dispatch({ type: setModalType, modalType: 'list_csv_data' });
        dispatch({ type: setModalOpen, modalOpen: true });
    };
    const handleCloseEmpty = () => {
        dispatch({ type: setSelectedCsvFile, selectedCsvFile: null });
        dispatch({ type: setSelectedCsvFileName, selectCsvFileName: '' });
        dispatch({ type: setParseDataOfCsvFile, parsedCsvData: [] });
        dispatch({ type: setModalOpen, modalOpen: false });
        dispatch({ type: setModalType, modalType: 'import-csv' });
        dispatch({ type: setModalOpen, modalOpen: true });
    };
    const handleDelete = () => {
        if (parsedCsvData && parsedCsvData?.length) {
            const newParsedCsvData = [...parsedCsvData];
            newParsedCsvData.splice(selectedCsvItemIndex, 1);
            dispatch({ type: setParseDataOfCsvFile, parsedCsvData: newParsedCsvData });
            if (!newParsedCsvData.length) {
                handleCloseEmpty();
                return;
            }
        }

        handleClose();
    };
    return (
        <>
            <Box className="modal-header">
                <Typography variant="h3" component="h3">
                    Remove "{selectedCsvItem?.Question || ''}" Title?
                </Typography>
            </Box>
            <Box className="modal-footer float-right">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Button variant="outlined" className="alternate-reversed w-full" onClick={handleDelete}>
                            Yes
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button variant="contained" className="alternate w-full" onClick={handleClose}>
                            No
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default RemoveTemmplateCsv;
